import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tooltip from '../Tooltip/Tooltip';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  dotHelpTip: {
    background: theme.palette.brand.orangeDark,
    width: theme.spacing(1.25),
    height: theme.spacing(1.25),
    borderRadius: '100%',
  },
  text: { maxWidth: 175 },
}));

export default function DotHelpTip({ text }) {
  const classes = useStyles();
  return (
    <Tooltip
      placement="top"
      arrow
      title={<Typography className={classes.text}>{text}</Typography>}
    >
      <div className={classes.dotHelpTip} />
    </Tooltip>
  );
}
